
/**
 * Shopify.CountryProvinceSelector
 * Minimal replacement of the old Shopify script to populate country and province dropdowns.
 */
var Shopify = Shopify || {};

Shopify.CountryProvinceSelector = function(countryDomId, provinceDomId, options) {
  this.countryEl = document.getElementById(countryDomId);
  this.provinceEl = document.getElementById(provinceDomId);
  this.provinceContainer = document.getElementById(options.hideElement);

  this.init();
};

Shopify.CountryProvinceSelector.prototype = {
  countries: {
    "United States": [
      "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
      "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
      "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
      "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
      "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon",
      "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah",
      "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
    ],
    "Canada": [
      "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador",
      "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec",
      "Saskatchewan", "Yukon"
    ],
    "Australia": [
      "Australian Capital Territory", "New South Wales", "Northern Territory", "Queensland",
      "South Australia", "Tasmania", "Victoria", "Western Australia"
    ]
  },

  init: function() {
    var countries = Object.keys(this.countries);

    this.countryEl.innerHTML = countries.map(function(country) {
      return '<option value="' + country + '">' + country + '</option>';
    }).join('');

    this.countryEl.addEventListener('change', this.updateProvinces.bind(this));

    this.updateProvinces(); // Load default provinces if any
  },

  updateProvinces: function() {
    var selectedCountry = this.countryEl.value;
    var provinces = this.countries[selectedCountry] || [];

    if (provinces.length > 0) {
      this.provinceEl.innerHTML = provinces.map(function(province) {
        return '<option value="' + province + '">' + province + '</option>';
      }).join('');
      this.provinceContainer.style.display = 'block';
    } else {
      this.provinceEl.innerHTML = '';
      this.provinceContainer.style.display = 'none';
    }
  }
};